"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSSuggest = void 0;
var React = require("react");
var context_1 = require("../context");
/** [[include:components/suggest.md]] */
var SSSuggest = /** @class */ (function (_super) {
    __extends(SSSuggest, _super);
    function SSSuggest() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /** @hidden */
    SSSuggest.prototype.render = function () {
        var _this = this;
        var props = __assign(__assign({}, this.props.props), { search: this.context.searchspring.query.search, autocomplete: this.context.searchspring.query.autocomplete, suggestions: this.context.searchspring.current.suggestions, setSearch: function (value) {
                _this.context.searchspring.setSearch(value);
                if (_this.props.onSetSearch) {
                    _this.props.onSetSearch(value);
                }
            }, setAutocomplete: function (value) {
                _this.context.searchspring.setAutocomplete(value);
                if (_this.props.onSetAutocomplete) {
                    _this.props.onSetAutocomplete(value);
                }
            }, getSuggestions: function () {
                _this.context.searchspring.getSuggestions(_this.context.searchspring.query.search);
                if (_this.props.onGetSuggestions) {
                    _this.props.onGetSuggestions(_this.context.searchspring.query.search);
                }
            } });
        if (this.props.render) {
            return this.props.render(props);
        }
        if (this.props.children) {
            return this.props.children(props);
        }
        if (this.props.component) {
            var SuggestComponent = this.props.component;
            return React.createElement(SuggestComponent, __assign({}, props));
        }
    };
    /** @hidden */
    SSSuggest.contextType = context_1.Context;
    return SSSuggest;
}(React.Component));
exports.SSSuggest = SSSuggest;
//# sourceMappingURL=suggest.js.map